<template>
  <div>
    <template v-if="disabled">
      {{ data }}
    </template>
    <flat-pickr
      v-else
      v-model="data"
      :disabled="disabled"
      :placeholder="$t('_components.placeholder.select')+label"
      class="form-control"
      :config="{ enableTime: true,dateFormat: 'H:i', allowInput: true, noCalendar: true }"
    />
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'

export default {
  components: {
    flatPickr,
  },
  props: {
    value: {
      type: [String, Number, Object, Array, Boolean],
      default: undefined,
    },
    option: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      data: undefined,
    }
  },
  watch: {
    data: {
      deep: true,
      handler(e) {
        this.$emit('input', this.data)
      },
    },
    value: {
      handler(e) {
        this.data = e
      },
      deep: true,
      // immediate: true,
    },
  },
  mounted() {
    this.initDictOption(this.value)
  },
  methods: {
    initDictOption(e) {
      this.data = e
    },
  },
}

</script>

<style lang='scss'>
@import '@core/scss/vue/libs/vue-flatpicker.scss';

</style>
